<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
    :footer="false"
  >
    <form class="t-walkthrough-ivr-guidance__form">
      <div class="t-walkthrough-ivr-guidance__description">
        <a-heading tag="h3" size="small">2. 自動音声ガイダンスの設定</a-heading>
        <a-text>設定した分岐を確認しながら自動音声ガイダンスで読み上げる内容をご入力ください。</a-text>
      </div>
      <div class="t-walkthrough-ivr-guidance__fields">
        <m-response-flow-summary
          class="t-walkthrough-ivr-guidance__response-flow"
          title="分岐ごとの応答設定"
          :list="flowList"
        />
        <m-automatic-responder-setting
          v-model:voice="formData.voice"
          v-model:content="formData.content"
          v-model:absence-mail="formData.absenceMail"
          v-model:email-notification="formData.emailNotification"
          response-mode="basic-voice-guidance"
          :voice-list="voiceList"
          :is-voice-playing="isVoicePlaying"
          @play="handlePlayVoice"
          @stop="handleStopVoice"
        />
      </div>
      <div class="t-walkthrough-ivr-guidance__buttons">
        <m-button-container>
          <a-button variant="block" color="primary" @click="handleSubmitForm">次へ</a-button>
          <a-button variant="outlined" color="primary" @click="handleCancelClick">戻る</a-button>
          <a-button color="primary" class="t-walkthrough-ivr-guidance__button-optional" @click="handleNotSettingClick"
            >初期設定はせずにホーム画面へ</a-button
          >
        </m-button-container>
      </div>
      <teleport to="body">
        <o-modal
          id="walkthroughIvrGuidance_resultModal"
          v-model:visible="resultModalVisible"
          class="o-modal-remove-phone-number-confirmation"
          footer-variant="confirmation"
          width="442px"
          :footer-shadow="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
        >
          <template #title>{{ resultModalTitle }}</template>
          <a-text>
            <!-- eslint-disable -->
            <span v-html="resultModalContent" />
            <!-- eslint-enable -->
          </a-text>
          <template #footer>
            <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
          </template>
        </o-modal>
      </teleport>
    </form>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import AHeading from '@/components/atoms/heading';
import AButton from '@/components/atoms/button';
import MButtonContainer from '@/components/molecules/button-container';
import AText from '@/components/atoms/text';
import MResponseFlowSummary from '@/components/molecules/response-flow-summary';
import MAutomaticResponderSetting from '@/components/molecules/automatic-responder-setting';
import { cloneDeep } from 'lodash';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';

export default {
  name: 't-walkthrough-ivr-guidance',
  components: {
    TDefaultEntrySidebar,
    AHeading,
    AButton,
    MButtonContainer,
    AText,
    MResponseFlowSummary,
    MAutomaticResponderSetting,
  },
  mixins: [customRequest, messageContent, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    // flowList: {
    //   type: Array,
    //   default: new Array(0),
    // },
    // voiceList: {
    //   type: Array,
    //   default: new Array(0),
    // },
    // handlePlayVoice: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleFormSubmit: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleNotSettingClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      flows: [],
      formData: {
        voice: null,
        content: '',
        absenceMail: '',
        emailNotification: false,
      },
      sidebarInfo: {
        sidebarList: [
          { label: 'ユーザー招待' },
          {
            label: '営業時間設定',
            subStepLabel: '営業時間設定する場合',
            steps: ['営業時間設定', '対応方法設定'],
          },
          {
            label: '着信フローの設定',
            subStepLabel: '分岐を設定する場合',
            steps: ['フロー設定', '自動音声ガイダンス設定'],
            currentStep: 2,
          },
        ],
        sidebarCurrent: 3,
        heading: '着信フローの設定',
        subHeading: 'Step 3',
        sidebarSubHeading: 'Walk Through',
        sidebarHeading: '初期設定',
      },
      flowList: [
        {
          label: 'プッシュ番号 1',
          active: false,
          name: '未設定',
        },
        {
          label: 'プッシュ番号 2',
          active: false,
          name: '未設定',
        },
        {
          label: 'プッシュ番号 3',
          active: false,
          name: '未設定',
        },
        {
          label: 'プッシュ番号 4',
          active: false,
          name: '未設定',
        },
        {
          label: 'プッシュ番号 5',
          active: false,
          name: '未設定',
        },
      ],
      voiceList: [
        {
          value: 'female2',
          label: '日本語 | 女性 | 大人 | 02',
        },
      ],

      //音声
      audio: null,
      isVoicePlaying: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-walkthrough-ivr-guidance');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    $route(to, from) {
      if (this.audio && this.audio.state === 'running') this.audio.close();
    },
  },
  mounted() {
    if (this.$route.params.formData) {
      this.flows = JSON.parse(String(this.$route.params.formData));
      this.formData.content = this.$route.params.guidance;
      for (const id in this.flows) {
        const flow = this.flows[id];
        this.flowList[id].active = flow.active;
        if (flow.settingName) {
          this.flowList[id].name = flow.settingName;
        }
      }
    } else {
      this.$router.push({ name: 'WTRoutingUserGroup' });
    }
  },
  methods: {
    handleSubmitForm(e) {
      e.preventDefault();
      this.formData.flows = this.flows;
      const payload = cloneDeep(this.formData);
      // console.log('payload', payload);
      if (this.validateForm(payload)) {
        if (payload && payload.content && payload.content.trim()) {
          const self = this;
          this.postRequest('/cotohattsupload', { data: { pbGuidance: payload.content } })
            .then(data => {
              if (data.status === 'success') {
                payload.pbGuidanceURL = data.data.guidanceURL ? data.data.guidanceURL.pbGuidanceURL : '';
                self.handleFormSubmit(payload);
              } else {
                self.showErrorModal(messageContent.requireTry('音声作成'));
              }
            })
            .catch(error => {
              self.showErrorModal(messageContent.requireTry('音声作成'));
            });
        }
      }
    },
    handleFormSubmit(formData) {
      //console.log('着信フローの設定');
      // console.log(formData);
      this.postRequest('/walkthrough/ivr-save', {
        companyID: this.companyID,
        formData: formData,
      })
        .then(res => {
          if (res.status === 'success') {
            this.$router.push({ name: 'WTComplete' });
          } else {
            this.showErrorModal(res.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    validateForm(formData) {
      // Validate guidance
      if (!formData.content) {
        this.showErrorModal(messageContent.guidanceRequired);
        return false;
      }
      // Only space check
      const onlySpaceChk = this.onlySpaceCheck(formData.content, 'ガイダンス内容');
      if (!onlySpaceChk.status) {
        this.showErrorModal(onlySpaceChk.message);
        return false;
      }
      if (formData.content && this.hasSpecialCharacterInObject(formData.content)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return false;
      }
      const lengthCheck = this.guidanceLengthCheck(formData.content);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return false;
      }
      const charCheck = this.guidanceCharCheck(formData.content);
      if (!charCheck.status) {
        this.showErrorModal(charCheck.message);
        return false;
      }
      // Validate email
      if (formData.emailNotification && !this.addressCheck(formData.absenceMail)) {
        this.showErrorModal(messageContent.alertNotCorrectFormat('メールアドレス'));
        return false;
      }
      return true;
    },
    handleCancelClick() {
      this.$router.push({
        name: 'WTRoutingUserGroup',
        params: { formData: this.$route.params.formData, guidance: this.formData.content },
      });
    },
    handleNotSettingClick() {
      this.updateFirstVisitFlag();
      this.$router.push({ name: 'Home' });
    },
    updateFirstVisitFlag(status = false) {
      this.postRequest('/walkthrough/update-firstVisitFlag', { status })
        .then(res => {
          if (res.status === 'success') {
            //console.log('firstVisitFlag is updated to', status);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    async handlePlayVoice(data) {
      if (!data.content) {
        this.showErrorModal(messageContent.requireInput('ガイダンス内容'));
        return;
      }
      if (data.content && this.hasSpecialCharacterInObject(data.content)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }
      const lengthCheck = this.guidanceLengthCheck(data.content);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return;
      }
      const charCheck = this.guidanceCharCheck(data.content);
      if (!charCheck.status) {
        this.showErrorModal(charCheck.message);
        return;
      }
      if (this.audio && this.audio.state === 'running') this.audio.close();
      this.isVoicePlaying = true;
      const self = this;
      await this.postRequest('/cotohattsupload/testvoice', { content: data.content })
        .then(async data => {
          if (data.status === 'success' && data.data.voiceBufferData) {
            self.audio = null;
            self.audio = new AudioContext();
            const arr = Uint8Array.from(data.data.voiceBufferData.data);
            const audio = await self.audio.decodeAudioData(arr.buffer);
            const source = self.audio.createBufferSource();
            source.buffer = audio;
            source.connect(self.audio.destination);
            source.start(0);
            source.onended = function () {
              self.isVoicePlaying = false;
            };
          } else {
            this.isVoicePlaying = false;
            self.showErrorModal(messageContent.requireTry('再生'));
          }
        })
        .catch(error => {
          this.isVoicePlaying = false;
          self.showErrorModal(messageContent.requireTry('再生'));
        });
    },
    handleStopVoice() {
      if (this.audio && this.audio.state === 'running') {
        const self = this;
        this.audio.close().then(function () {
          self.isVoicePlaying = false;
        });
      }
    },
  },
};
</script>
